module.exports = __webpack_public_path__ + "img/goldenbrush.2c8f9ce9.png";